import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskEndSoonUI = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskEndSoonUI;
